import React from "react";
import ReactDOM from "react-dom/client";
import { initializeAnalytics } from "@/lib/analytics";
import App from "./App";
import AppProviders from "./AppProviders";
import "./main.css";
import { appConfig } from "./services/AppConfig";

initializeAnalytics(appConfig.googleAnalyticsId, appConfig.stage);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);

// Service-worker registration is removed — public/service-worker.js is
// a tombstone that self-unregisters on activate. Registering a new one
// here would resurrect it on every page load.
//
// Listeners below are defensive catch-alls for the residual population
// of users whose browser still has the old cache-first SW installed:
//
// 1. `controllerchange` — fires when the tombstone takes over via
//    `clients.claim()`. We reload so the tab stops rendering the stale
//    cached SPA that the old SW served for the current navigation.
// 2. `message` from the SW — the tombstone calls `client.navigate()`
//    first (Chromium path); if that throws, it posts this message as
//    a fallback for non-Chromium browsers.
//
// First-visit caveat: when a fresh SW calls `clients.claim()` it also
// triggers `controllerchange` with `controller === null` beforehand,
// and we don't want to reload in that case. The `hadController` flag
// gates on "was the page already controlled" so only genuine handoffs
// trigger the reload.
if ("serviceWorker" in navigator) {
  const hadController = navigator.serviceWorker.controller != null;
  let reloading = false;
  const reloadOnce = () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!hadController) return;
    reloadOnce();
  });

  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "tombstone-reload") {
      reloadOnce();
    }
  });
}
